const currencyUnit = [
  {
    label: 'IDR',
    value: 'IDR',
  },
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'THB',
    value: 'THB',
  },
  {
    label: 'SGD',
    value: 'SGD',
  },
  {
    label: 'PHP',
    value: 'PHP',
  },
  {
    label: 'CNY',
    value: 'CNY',
  },
  {
    label: 'AUD',
    value: 'AUD',
  },
]

const CURRENCIES = [
    { value: 'AUD', label: 'AUD' },
    { value: 'CNY', label: 'CNY' },
    { value: 'EUR', label: 'EUR' },
    { value: 'IDR', label: 'IDR' },
    { value: 'INR', label: 'INR' },
    { value: 'JPY', label: 'JPY' },
    { value: 'KRW', label: 'KRW' },
    { value: 'MYR', label: 'MYR' },
    { value: 'PHP', label: 'PHP' },
    { value: 'SGD', label: 'SGD' },
    { value: 'THB', label: 'THB' },
    { value: 'USD', label: 'USD' },
]

const quantityUnit = [
  {
    label: 'Pcs',
    value: 'pcs',
  },
  {
    label: 'Sheets',
    value: 'sheets',
  },
  {
    label: 'Box',
    value: 'box',
  },
  {
    label: 'Crt',
    value: 'crt',
  },
  {
    label: 'Lsn',
    value: 'lsn',
  },
  {
    label: 'Pak',
    value: 'pak',
  },
  {
    label: 'Pack',
    value: 'pack',
  },
  {
    label: 'Set',
    value: 'set',
  },
  {
    label: 'Kg',
    value: 'kg',
  },
  {
    label: 'Ton',
    value: 'ton',
  },
  {
    label: 'Rol',
    value: 'rol',
  },
  {
    label: 'Bag',
    value: 'bag',
  },
  {
    label: 'Mtr',
    value: 'mtr',
  },
  {
    label: 'Dzn',
    value: 'dzn',
  },
  {
    label: 'Ltr',
    value: 'ltr',
  },
]

const weightUnit = [
  {
    label: 'Kgs',
    id: 'kg',
  },
  {
    name: 'Gram',
    id: 'gr',
  },
  {
    name: 'Pounds',
    id: 'lbs',
  },
  {
    name: 'Ounce',
    id: 'oz',
  },
]

const dimensionUnit = [
  {
    label: 'Meter (m)',
    value: 'm',
  },
  {
    label: 'Centimeter (cm)',
    value: 'cm',
  },
  {
    label: 'Feet (ft)',
    value: 'ft',
  },
  {
    label: 'Inch (inch)',
    value: 'inch',
  },
]

const bundleUnit = [
  {
    label: 'CRT',
    value: 'crt',
  },
  {
    label: 'LSN',
    value: 'lsn',
  },
  {
    label: 'BOX',
    value: 'box',
  },
  {
    label: 'PAK',
    value: 'pak',
  },
  {
    label: 'SET',
    value: 'set',
  },
  {
    label: 'GRS',
    value: 'grs',
  },
  {
    label: 'PCS',
    value: 'pcs',
  },
]

const shipmentMethodType = [
  {
    label: 'Air Cargo',
    value: 'air',
  },
  {
    label: 'Ocean Cargo',
    value: 'ocean',
  },
  {
    label: 'Air Cargo Door to Door',
    value: 'air_dtd',
  },
  {
    label: 'Ocean Cargo Door to Door',
    value: 'ocean_dtd',
  },
  {
    label: 'Air Courier',
    value: 'air_courier',
  },
  {
    label: 'Domestic',
    value: 'domestic',
  },
  {
    label: 'Official Trucking',
    value: 'official_trucking',
  },
  {
    label: 'Unofficial Trucking',
    value: 'unofficial_trucking',
  },
]

const shipmentMethod = {
  'air': 'Air Cargo',
  'ocean': 'Ocean Cargo',
  'air_dtd': 'Air Cargo Door to Door',
  'ocean_dtd': 'Ocean Cargo Door to Door',
  'air_courier': 'Air Courier',
  'domestic': 'Domestic',
  'official_trucking': 'Official Trucking',
  'unofficial_trucking': 'Unoficial Trucking'
}

const additionalChargeType = [
  {
    label: 'ORIGIN CHARGE',
    value: 'ORIGIN_CHARGE'
  },
  {
    label: 'FREIGHT CHARGE',
    value: 'FREIGHT_CHARGE'
  },
  {
    label: 'DESTINATION CHARGE',
    value: 'DESTINATION_CHARGE'
  },
  {
    label: 'HANDLING CHARGE',
    value: 'HANDLING_CHARGE'
  },
  {
    label: 'LAST MILE CHARGE',
    value: 'LAST_MILE_CHARGE'
  },
  {
    label: 'OTHER CHARGE',
    value: 'OTHER_CHARGE '
  },
  {
    label: 'SELLING CHANNEL CHARGE',
    value: 'SELLING_CHANNEL_CHARGE'
  },
  {
    label: 'CASH ON DELIVERY CHARGE',
    value: 'CASH_ON_DELIVERY_CHARGE'
  },
  {
    label: 'VAT',
    value: 'VAT_CHARGE'
  },
]

const additionalCharge = {
  'ORIGIN_CHARGE': 'ORIGIN CHARGE',
  'FREIGHT_CHARGE': 'FREIGHT CHARGE',
  'DESTINATION_CHARGE': 'DESTINATION CHARGE',
  'HANDLING_CHARGE': 'HANDLING CHARGE',
  'LAST_MILE_CHARGE': 'LAST MILE CHARGE',
  'OTHER_CHARGE': 'OTHER CHARGE',
  'SELLING_CHANNEL_CHARGE': 'SELLING CHANNEL CHARGE',
  'CASH_ON_DELIVERY_CHARGE': 'CASH ON DELIVERY CHARGE',
  'VAT_CHARGE': 'VAT' 
}

const orderType = [
  {
    value: 'trading',
    label: 'Trading',
  },
  {
    value: 'forwarding',
    label: 'Forwarding',
  },
]

const orderCategory = [
  {
    value: 'import',
    label: 'Import',
  },
  {
    value: 'export',
    label: 'Export',
  },
  {
    value: 'local',
    label: 'Local',
  },
  {
    value: 'cod',
    label: 'COD',
  },
  {
    value: 'virtual',
    label: 'Virtual',
  },
  {
    value: 'inbound',
    label: 'Inbound',
  },
  {
    value: 'outbound',
    label: 'Outbound',
  },
]

const typeQuoteList = [
  {
    label: 'Sourcing Quote',
    value: 'SOURCING',
  },
  {
    label: 'Procurement Quote',
    value: 'PROCUREMENT',
  },
]

// package type
const packageTypeList = [
  {
    label: 'Regular',
    value: 'regular',
  },
  {
    label: 'Carton',
    value: 'carton',
  },
]


const bulkUnitList = ['crt']

const orderTerms = ['FOB', 'EXW', 'CIF', 'FCA', 'FAS', 'CNF', 'DDU', 'DDP']

const orderLoadType = ['LCL', 'FCL 20"', 'FCL 40"', 'FCL 40" HC', 'FCL 45" HC', 'FCL 20" Reefer', 'FCL 40" Reefer', 'FCL 40" HC Reefer', 'LTL', 'FTL', 'Standard']

export { CURRENCIES, currencyUnit, quantityUnit, weightUnit, dimensionUnit, bundleUnit, shipmentMethodType, shipmentMethod, orderType, orderCategory, orderTerms, orderLoadType, typeQuoteList, packageTypeList, bulkUnitList, additionalCharge, additionalChargeType }
